<!--
 * @Author: ZhaoG
 * @Date: 2026-03-05 14:54:00
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-04-15 11:32:34
 * @FilePath: \sra-fe\src\views\register\material\maPerfectInfo\addGreenProducts.vue
 * @Description:绿色产品列表
-->
<template>
  <div class="content">
    <div class="btn">
      <el-button size="mini" @click="handleAdd">{{
        $t("page.greenLowCarbon.table.addBtn")
      }}</el-button>
    </div>
    <div class="tableBox">
      <el-table :data="tableData" border style="width: 100%">
        <!-- 产品名称 -->
        <el-table-column align="center">
          <template slot="header" slot-scope="scope">
            <span style="color: red;">*</span
            >{{ $t("page.greenLowCarbon.table.isGreenProduction") }}
          </template>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.productName"
              :placeholder="
                $t('page.greenLowCarbon.table.isGreenProductionPlaceholder')
              "
              @focus="getProductList(scope.$index, scope.row)"
            ></el-input>
          </template>
        </el-table-column>

        <!-- 是否是绿色产品认证 -->
        <el-table-column
          :label="$t('page.greenLowCarbon.table.isGreenProductCertification')"
          align="center"
        >
          <template slot-scope="scope">
            <el-radio-group
              v-model="scope.row.greenCertificationFlag"
              size="mini"
              @change="handleGreenCertificationFlagChange(scope.row)"
            >
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
              }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
              }}</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>

        <!-- 绿色产品认证星级 -->
        <el-table-column
          :label="
            $t('page.greenLowCarbon.table.greenProductCertificationRating')
          "
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.greenCertificationLevel"
              clearable
              :disabled="scope.row.greenCertificationFlag == '0'"
              :placeholder="
                $t(
                  'page.greenLowCarbon.table.greenProductCertificationRatingPlaceholder'
                )
              "
            >
              <el-option
                v-for="(item, index) in greenProductCertificationRatingOption"
                :key="index"
                :label="item.dictName"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>

        <!-- 对应的【绿色产品认证证书/绿色产品标识】附件名称 -->
        <el-table-column
          prop="greenProductCertificationFileName"
          :label="
            $t('page.greenLowCarbon.table.greenProductCertificationFileName')
          "
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleFileView(scope.$index, scope.row, 'green')"
              :disabled="scope.row.greenCertificationFiles.length == 0"
              >{{ $t("page.greenLowCarbon.table.view") }}</el-button
            >
          </template>
        </el-table-column>

        <!-- 上传对应的【产品碳足迹证书】或【产品碳足迹报告】附件 -->
        <el-table-column
          :label="$t('page.greenLowCarbon.table.greenProductCertificationFile')"
          class="operation"
        >
          <template slot-scope="scope">
            <el-upload
              :show-file-list="false"
              :action="uploadUrl"
              class="upload-demo tow"
              :on-progress="e => onProgress(e, 'green')"
              :on-change="
                (file, fileList) => handleFileChange(file, fileList, 'green',scope.$index,
                    scope.row)
              "
              multiple
              accept=".png,.jpg,.jpeg,.gif,.webp,.pdf,"
              :before-upload="file => beforeAvatarUpload(file, 'green')"
              :on-success="
                (res, file, fileList) => onSuccess(res, file, fileList, 'clean')
              "
              :on-error="
                (err, file, fileList) => onError(err, file, fileList, 'green')
              "
            >
              <el-button
                type="text"
                :disabled="scope.row.greenCertificationFlag == '0'"
                @click="getIndex(scope.$index, scope.row.id)"
                >{{ $t("page.qualificationFile.btn.uploading") }}</el-button
              >
              <!-- 上传 -->
            </el-upload>
          </template>
        </el-table-column>

        <!-- 是否进行了产品碳足迹核算 -->
        <el-table-column
          :label="
            $t('page.greenLowCarbon.table.ProductCarbonFootprintAccounting')
          "
          align="center"
        >
          <template slot-scope="scope">
            <el-radio-group 
              v-model="scope.row.carbonFootstepFlag" 
              size="mini"
              @change="handleCarbonFootstepFlagChange(scope.row)"
            >
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
              }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
              }}</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>

        <!-- 产品碳足迹数值 -->
        <el-table-column
          :label="$t('page.greenLowCarbon.table.ProductCarbonFootprintValue')"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.carbonFootstepValue"
              :placeholder="
                $t(
                  'page.greenLowCarbon.table.ProductCarbonFootprintValuePlaceholder'
                )
              "
              :disabled="scope.row.carbonFootstepFlag == '0'"
              @blur="handleCarbonFootstepBlur(scope.row)"
              @input="scope.row.carbonFootstepError = ''"
              style="width: 150px;"
            ></el-input>
            <div
              v-if="scope.row.carbonFootstepError"
              style="color: #f56c6c; font-size: 12px; margin-top: 2px;"
            >
              {{ scope.row.carbonFootstepError }}
            </div>
          </template>
        </el-table-column>

        <!-- 对应的【绿色产品认证证书/绿色产品标识】附件名称 -->
        <el-table-column
          prop="ProductCarbonFootprintFileName"
          :label="
            $t('page.greenLowCarbon.table.ProductCarbonFootprintFileName')
          "
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleFileView(scope.$index, scope.row, 'clean')"
              :disabled="scope.row.carbonFootstepFiles.length == 0"
              >{{ $t("page.greenLowCarbon.table.view") }}</el-button
            >
          </template>
        </el-table-column>

        <!-- 对应的【绿色产品认证证书/绿色产品标识】附件上传和删除按钮 -->
        <el-table-column
          :label="$t('page.greenLowCarbon.table.ProductCarbonFootprintFile')"
          class="operation"
        >
          <template slot-scope="scope">
            <el-upload
              :show-file-list="false"
              :action="uploadUrl"
              class="upload-demo tow"
              :on-progress="e => onProgress(e, 'clean')"
              :on-change="
                (file, fileList) => handleFileChange(file, fileList, 'clean',scope.$index,
                    scope.row)
              "
              multiple
              accept=".png,.jpg,.jpeg,.gif,.webp,.pdf,.doc,.docx"
              :before-upload="file => beforeAvatarUpload(file, 'clean')"
              :on-success="
                (res, file, fileList) => onSuccess(res, file, fileList, 'clean')
              "
              :on-error="
                (err, file, fileList) => onError(err, file, fileList, 'clean')
              "
            >
              <el-button
                type="text"
                :disabled="scope.row.carbonFootstepFlag == '0'"
                @click="getIndex(scope.$index, scope.row.id)"
                >{{ $t("page.qualificationFile.btn.uploading") }}</el-button
              >
              <!-- 上传 -->
            </el-upload>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('page.greenLowCarbon.table.operation')"
          class="operation"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="deleteAppend(scope.$index, scope.row)"
              class="removeBtn"
              :disabled="tableData.length < 2"
              >{{ $t("page.qualificationFile.btn.del") }}</el-button
            >
            <!-- 删除 -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 文件列表弹窗 -->
    <FileListDialog
      :dialogFormVisible.sync="fileDialogVisible"
      :file-list="currentFileList"
      title="附件文件列表"
      :type="'1'"
      @handleDelete="handleFileDelete"
      @handlePreview="previewFile"
      @handleClose="handleClose"
    />
    <chooseTree
      :dialogFormVisible.sync="dialogFormVisible"
      :greenCarbonType="greenCarbonType"
      :default-data="defaultData"
      @handleTrue="handleTrue"
    >
    </chooseTree>
  </div>
</template>

<script>
import { Loading } from "ccui";
import chooseTree from "./chooseTree1";
import { qrySmpcSysDictListByType } from "@/api/supRegister";
import { getPreviewUrl } from "@/utils";
import FileListDialog from "./FileListDialog.vue";
export default {
  components: { chooseTree, FileListDialog },
  props: {
    temGreenInfo: {
      type: Array,
      default: () => []
    },
    greenCarbonType: {
      type: String,
      default: ""
    }
  },
  data() {
    let baseUrl = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    return {
      defaultData: [],
      tableData: [this.createEmptyRow()],
      greenProductCertificationRatingOption: [],
      uploadUrl: baseUrl + "/apis/sra/oss/users/signup/uploadFilePersNew", //上传图片
      uploadLoading: null,
      fileList: [],
      fileLists: [],
      greenCertificationFiles: [],
      carbonFootstepFiles: [],
      rowId: "",
      index: 0,
      visibleIndex: 0,
      materialDirectoryShow: false, // 是否显示物料目录弹窗
      dialogFormVisible: false, // 是否显示物料目录弹窗
      selectData: [], // 选择的数据
      opUnitId: "0",
      materialDirectoryType: 2, //1是多选2是单选
      shebeioryunshu: "", //tran为运输设备物资
      fileDialogVisible: false, // 文件列表弹窗显示状态
      currentFileList: [], // 当前展示的文件列表
      currentRowIndex: 0, // 当前行索引
      currentFileType: ""
    };
  },
  watch: {
    temGreenInfo: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          newVal.forEach(item => {
            item.productName =
              item.matcateryNameMid + "-" + item.matcateryNameSmall;
          });
          // this.tableData = JSON.parse(JSON.stringify(newVal));
          const list = JSON.parse(JSON.stringify(newVal));
          // 为每一行初始化 carbonFootstepError，确保校验提示能正常显示
          list.forEach((row) => {
            if (row.carbonFootstepError === undefined) {
              row.carbonFootstepError = "";
            }
          });
          this.tableData = list;
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // 供应商通用产品认证-等级
    qrySmpcSysDictListByType({ dictType: "SUP_GREEN_TYPE_CERTIFICATION" }).then(
      res => {
        if (res.data.code == 0) {
          this.greenProductCertificationRatingOption = res.data.data;
        }
      }
    );
  },
  methods: {
    handleClose() {
      this.fileDialogVisible = false;
    },
    // 查看文件列表
    handleFileView(index, row, type) {
      this.currentRowIndex = index;
      this.currentFileType = type;
      // 根据碳足迹文件或绿色认证文件决定展示哪个列表
      if (type == "clean") {
        this.currentFileList = row.carbonFootstepFiles;
      } else {
        this.currentFileList = row.greenCertificationFiles;
      }

      this.fileDialogVisible = true;
    },
    // 处理文件删除
    handleFileDelete({ index, row }) {
      // 动态获取当前最高 zIndex，确保确认弹窗在最上层
      const getTopZIndex = () => {
        const dialogs = document.querySelectorAll(".el-dialog__wrapper");
        let maxZIndex = 2000;
        dialogs.forEach((dialog) => {
          const zIndex = parseInt(window.getComputedStyle(dialog).zIndex);
          if (zIndex && zIndex > maxZIndex) {
            maxZIndex = zIndex;
          }
        });
        return maxZIndex;
      }; // ✅ 二次确认
      // ✅ 二次确认
      this.$confirm("确定要删除该文件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        Index: getTopZIndex() + 100,
        type: "warning"
      })
        .then(() => {
          const currentRow = this.tableData[this.currentRowIndex];

          // ✅ 根据文件类型从正确的数组中删除
          if (this.currentFileType === "clean") {
            // 删除碳足迹文件
            if (
              currentRow.carbonFootstepFiles &&
              currentRow.carbonFootstepFiles.length > index
            ) {
              currentRow.carbonFootstepFiles.splice(index, 1);
              this.carbonFootstepFiles = currentRow.carbonFootstepFiles;
            }
          } else {
            // 删除绿色认证文件
            if (
              currentRow.greenCertificationFiles &&
              currentRow.greenCertificationFiles.length > index
            ) {
              currentRow.greenCertificationFiles.splice(index, 1);
              this.greenCertificationFiles = currentRow.greenCertificationFiles;
            }
          }

          // ✅ 使用 $set 确保视图更新
          this.$set(this.tableData, this.currentRowIndex, currentRow);

          // ✅ 通知父组件数据已变更
          this.$emit("handleGreenProduct", this.tableData);

          this.$message.success("删除成功");
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    handleAdd() {
      const newRow = this.createEmptyRow();
      this.tableData.push(newRow);
    },

    // 抽取创建空行方法
    createEmptyRow() {
      return {
        greenCertificationFlag: "0",
        productName: "",
        carbonFootstepFlag: "0",
        carbonFootstepValue: "",
        carbonFootstepError: "",
        carbonFootstepFiles: [],
        greenCertificationFiles: []
      };
    },
    deleteAppend(i, row) {
      this.tableData.splice(i, 1);
    },
    // 校验碳足迹数值：只能输入>0的数字，最多保留两位小数，最长20位
    handleCarbonFootstepBlur(row) {
      const value = row.carbonFootstepValue;
      if (!value) {
        row.carbonFootstepError = "";
        return;
      }
      const str = String(value);
      if (str.length > 20) {
        row.carbonFootstepError = "最多输入20位字符";
        return;
      }
      const numPattern = /^\d+(\.\d{1,2})?$/;
      if (!numPattern.test(str)) {
        row.carbonFootstepError = "只能输入大于0的数字，最多保留两位小数";
        return;
      }
      const num = parseFloat(str);
      if (num <= 0) {
        row.carbonFootstepError = "只能输入大于0的数字";
        return;
      }
      row.carbonFootstepError = "";
    },
    //添加产品弹框点击确定
    handleTrue(data) {
      const formattedData = data.map(item => {
        return {
          parentMatcateryCode: item.parentMatcateryCode,
          matcateryTreePath: item.matcateryTreePath,
          matcateryCode: item.id,
          matcateryName: item.name,
          matTrademark: "",
          prodinfoRemark: "",
          matcateryCodeMid: item.matcateryCodeMid,
          matcateryNameMid: item.matcateryNameMid,
          matcateryCodeSmall: item.matcateryCodeSmall,
          matcateryNameSmall: item.matcateryNameSmall,
          matcateryCodeBig: item.matcateryCodeBig,
          matcateryNameBig: item.matcateryNameBig,
          productName: item.matcateryNameMid + "-" + item.name,
          greenCertificationFlag: "0",
          carbonFootstepFlag: "0",
          carbonFootstepValue: "",
        carbonFootstepError: "",
          carbonFootstepFiles: [],
          greenCertificationFiles: []
        };
      });

      // 判断是否为空行
      const isEmptyRow = row => row && row.productName === "";

      // 根据 visibleIndex 确定插入位置
      if (this.visibleIndex >= 0 && this.visibleIndex < this.tableData.length) {
        const currentRow = this.tableData[this.visibleIndex];

        if (isEmptyRow(currentRow)) {
          // ✅ 当前行无值：选中几个值就添加几行（直接插入到当前位置）
          this.tableData.splice(this.visibleIndex, 1, ...formattedData);
        } else {
          // ✅ 当前行有值：第一条替换当前行，其余数据在当前行后新增
          if (formattedData.length > 0) {
            const firstRow = formattedData[0];
            const restRows = formattedData.slice(1);

            // 替换当前行
            this.$set(this.tableData, this.visibleIndex, firstRow);
            this.$set(this.tableData, "carbonFootstepFlag", []);
            this.$set(this.tableData, "greenCertificationFiles", []);

            // 在当前位置之后插入剩余数据
            if (restRows.length > 0) {
              this.tableData.splice(this.visibleIndex + 1, 0, ...restRows);
            }
          }
        }
      } else {
        // 默认追加到末尾
        this.tableData = [...this.tableData, ...formattedData];
      }

      this.$emit("handleGreenProduct", this.tableData);
    },
    getProductList(i, row) {
      this.visibleIndex = i;
      this.materialDirectoryShow = true;
      this.dialogFormVisible = true;
    },
    getIndex(index, id) {
      this.index = index;
      this.rowId = id;
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    //预览
    async previewFile({ uploadId, uploadIdStr }) {
      if (uploadIdStr) {
        getPreviewUrl(uploadIdStr);
      } else {
        getPreviewUrl(uploadId);
      }
    },

    // 下载文件
    downloadFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sra/reg/users/signup/downloadByFileUrl?fileUrl=${
        row.ossUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    // 文件变化处理
    handleFileChange(file, fileList, type,index,row) {
      let fieldName = "";
      switch (type) {
        case "green":
          fieldName = "greenCertificationFiles";
          break;

        case "clean":
          fieldName = "carbonFootstepFiles";
          break;

        default:
          break;
      }
// ✅ 只从 file.response 获取新文件信息，不从 fileList 重建
if (
        file.response &&
        file.response.data &&
        file.response.data.length > 0
      ) {
        const newFile = file.response.data[0];
        newFile.fileUrl = newFile.downloadUrl;
        newFile.fileName = newFile.fileName || file.name;

        // ✅ 获取当前行的文件数组
        const fileArray = row[fieldName] || [];

        // ✅ 检查是否已存在（避免重复添加）
        const exists = fileArray.some(
          (item) =>
            item.uploadId === newFile.uploadId ||
            item.fileName === newFile.fileName
        );

        if (!exists) {
          // ✅ 只添加新文件
          fileArray.push(newFile);
          row[fieldName] = fileArray;
          this.$set(this.tableData, index, row);
          this.$emit("handleGreenProduct", this.tableData);
        }
      }

    },

    // 上传进度
    onProgress(progressEvent, type) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      if (progressEvent.percent > 90) {
        progressEvent.percent = 98;
      }
    },

    // 上传成功
    onSuccess(res, file, fileList, type) {
      this.uploadLoading.close();
      if (res.code === "0") {
        this.$message.success(window.$t("page.greenLowCarbon.info.upload1"));
      }
    },

    // 上传错误
    onError(err, file, fileList, type) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading.close();
    },

    // 上传前校验
    beforeAvatarUpload(file, type) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      let imgType = [];
      let isUpload = true;
      let fileTypeLen = file.name.split(".");
      if (type == "clean") {
        imgType = ["doc", "docx", "jpg", "jpeg", "png", "gif", "webp", "pdf"];
      } else {
        imgType = ["jpg", "jpeg", "png", "gif", "webp", "pdf"];
      }
      const isLt400k = file.size / 1024 / 1024 < 15;
      let isImg = imgType.includes(
        fileTypeLen[fileTypeLen.length - 1].toLowerCase()
      );

      if (!isImg) {
        this.uploadLoading.close();
        this.$message({
          type: "error",
          message: window.$t("page.greenLowCarbon.contentLabel.uploadErr1")
        });
        isUpload = false;
      } else if (!isLt400k) {
        this.uploadLoading.close();
        this.$message({
          type: "error",
          message: window.$t("page.greenLowCarbon.contentLabel.uploadErr2")
        });
        isUpload = false;
      }

      return isUpload;
    },
    
    // 绿色认证等级变化处理
    handleGreenCertificationFlagChange(row) {
      if (row.greenCertificationFlag == "0") {
        row.greenCertificationLevel = "";
        row.greenCertificationFiles = [];
      }
      this.$emit("handleGreenProduct", this.tableData);
    },
    // 绿色认证等级变化处理
    handleCarbonFootstepFlagChange(row) {
      if (row.carbonFootstepFlag == "0") {
        row.carbonFootstepValue = "";
        row.carbonFootstepFiles = [];
      }
      this.$emit("handleGreenProduct", this.tableData);
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  padding: 20px;

  .btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }

  /deep/ .el-radio {
    margin-right: 10px;
  }
}
</style>
